import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import "../../assets/css/table-cell.css";
import "../../assets/css/common-table.css";
import phoneIcon from "../../assets/icons/akar-icons_phone.svg";
import emailIcon from "../../assets/icons/carbon_email.svg";
import PrivateGigTag from '../../assets/icons/PrivateGigTag.svg'
import {impersonate} from "../../utils/Utils";
import dayjs from "dayjs";
import { USER_TYPE } from "../../constant";
import AdminAndAbs from "../AdminTag/AdminAndAbs";

const columns = [
  {
    title: "Employer Details",
    dataIndex: "emplyer_details",
    key: "emplyer_details",
  },
  {
    title: "Company",
    dataIndex: "company",
    key: "company",
  },
  {
    title: "Employer Type",
    dataIndex: "employer_type",
    key: "employer_type",
  },
  {
    title: "Profession",
    dataIndex: "profession",
    key: "profession",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
];

export default function EmployerTable() {
  
  var localizedFormat = require("dayjs/plugin/localizedFormat");
  dayjs.extend(localizedFormat);
  
  const { employers, isLoading } = useSelector((state) => state.employer);
  const [dataSource, setDataSource] = useState([]);
  const [tableKey, setTableKey] = useState(Date.now());

  const employerRow = (item) => {
    return {
      key: `${item._id}`,
      emplyer_details: (
        <div className={"UserCell"}>
          <div className="UserPicName">
            {item?.Profiles?.PictureUrl && !item?.Profiles?.PictureUrl.includes("no-pic")  ? (
                <img
                  src={process.env.REACT_APP_S3_URL + "/" + item?.Profiles?.PictureUrl}
                  alt=""
                  onError={(e) => (e.target.src = `${process.env.REACT_APP_S3_URL}/content/img/no-pic.png`)}
                />
              ) : (
                <span className="UserChar">
                  {item?.Profiles?.FirstName ? item?.Profiles?.FirstName.slice(0, 1).toUpperCase() : "N"}
                </span>
              )}
            <span className="UserFullName">
              <span>
                {item.Profiles.FirstName == null &&
                item.Profiles.LastName == null
                  ? "NA"
                  : item.Profiles.FirstName + " " + item.Profiles.LastName}
              </span>
            </span>
            <AdminAndAbs isAdmin={item?.isAdmin}
              isAbs={item?.isAbs}
            />

          </div>
          <div className="UserOtherInfo">
            <div className={"UserOtherInfoInside"}>
              <img
                src={emailIcon}
                alt=""
              />
              <span>
                {item.EmailAddress == null ? "NA" : item.EmailAddress}
              </span>
            </div>
            <div className="UserOtherInfoInside">
              <img src={phoneIcon} alt="" />
              <span>
                {" "}
                {item.Profiles.MobilePhone == null
                  ? "NA"
                  : "+1 " + item.Profiles.MobilePhone}
              </span>
            </div>
          </div>
        </div>
      ),
      company: `${item.Profiles.CompanyName}` ? `${item.Profiles.CompanyName}` : "NA",
      employer_type: item.IsPrivateEmployer ? <img src={PrivateGigTag} alt="" /> : "",
      profession: `${
        item?.Professions?.ProfessionCode == null
          ? "NA"
          : item?.Professions?.ProfessionCode
      }`,
      status: (
        <div className={"StatusCell"}>
          <div className={"Status"}>
            {item.IsActive == 0 ? (
              <span className={"StatusInactive"}>Inactive</span>
            ) : (
              <span className={"StatusActive"}>Active</span>
            )}
          </div>
          <div>
            <div className={"CreadtedTime"}>
              Created on{" "}
              {item.Created !== ""
                ? dayjs(item.Created).format("LLL").replace(",", "")
                : "NA"}
            </div>
            <div className={"CreadtedTime"}>
              Last Login on{" "}
              {item.LastLoginDate !== null
                ? dayjs(item.LastLoginDate).format("LLL").replace(",", "")
                : dayjs(item.Created).format("LLL").replace(",", "")}
            </div>
          </div>
        </div>
      ),
    };
  };

  useEffect(() => {
    if (employers.length > 0) {
      let employersData = employers[0].data;
      let data = [];
      employersData.map((item) => {
        data.push(employerRow(item));
      });
      setDataSource(data);
      setTableKey(Date.now());
    }
  }, [employers]);

  return (
    <>
      <Table
        key={tableKey} 
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
        bordered
        pagination={false}
        onRow={(record) => ({ onClick: () => impersonate(USER_TYPE.EMPLOYER, record.key) })}
      />
    </>
  );
}
